/* Gesamtzahl der Living-Root-Bewertungen live von reviews.io holen.

   WARUM NICHT AUS DEN SHOPIFY-METAFELDERN?
   Die reviews.io-App schreibt pro Produkt reviewscouk.total. Fuer Reset C (29)
   und Clean Flam (28) stimmt der Wert, fuer Basic Gold stand dort 44, waehrend
   reviews.io selbst nur 22 Produktbewertungen kennt – also genau das Doppelte.
   Neben dem Pruefsiegel "geprüft durch reviews.io" darf keine hoehere Zahl
   stehen als die, die reviews.io selbst ausweist (§ 5 UWG, Anhang zu § 3
   Abs. 3 UWG Nr. 23b). Deshalb fragen wir die Quelle direkt.

   ZWEI ENDPUNKTE, weil reviews.io zwei Arten von Bewertungen fuehrt:
     product/review  – Produktbewertungen ueber alle vier SKUs
     merchant/latest – Shop-/Servicebewertungen
   Die Summe ist die Zahl, die reviews.io auch als Gesamtwert fuer den Shop
   ausweist. Deshalb ist der Text mit "für Living Root®" beschriftet und nicht
   mit dem Produktnamen – es sind nicht 103 Bewertungen fuer Basic Gold.

   Ergebnis wird 12 Stunden im sessionStorage gehalten, damit nicht jeder
   Seitenaufruf zwei Requests ausloest. Faellt der Abruf aus, bleibt der
   serverseitig gerenderte Stand stehen – der ist nie zu hoch, weil die Zahl
   nur waechst.

   SKU-Liste bei neuen Produkten hier ergaenzen. */
(function () {
  var SKUS = 'LR_BGC_EP;LR_RCC_EP;LR_CFC_EP;LR_BNDL_BC_CFC_RCC';
  var STORE = 'livingroot.de';
  var KEY = 'lr_reviews_total_v1';
  var MAX_AGE = 12 * 60 * 60 * 1000;

  function paint(count, rating) {
    if (!count) return;
    var i;
    var c = document.querySelectorAll('[data-lr-rev-count]');
    for (i = 0; i < c.length; i++) c[i].textContent = count;

    if (!rating) return;
    var r = document.querySelectorAll('[data-lr-rev-rating]');
    var txt = rating.toFixed(2).replace('.', ',');
    for (i = 0; i < r.length; i++) r[i].textContent = txt;

    var s = document.querySelectorAll('[data-lr-rev-stars]');
    var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
    for (i = 0; i < s.length; i++) s[i].style.width = pct.toFixed(1) + '%';
  }

  function cached() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (Date.now() - o.t > MAX_AGE) return null;
      return o;
    } catch (e) { return null; }
  }

  function store(count, rating) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ c: count, r: rating, t: Date.now() }));
    } catch (e) { /* privater Modus – egal */ }
  }

  function load() {
    var hit = cached();
    if (hit) { paint(hit.c, hit.r); return; }

    var pUrl = 'https://api.reviews.io/product/review?store=' + STORE +
               '&sku=' + encodeURIComponent(SKUS) + '&per_page=1';
    var mUrl = 'https://api.reviews.io/merchant/latest?store=' + STORE + '&per_page=1';

    Promise.all([
      fetch(pUrl).then(function (r) { return r.json(); }),
      fetch(mUrl).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var ps = (res[0] && res[0].stats) || {};
      var ms = (res[1] && res[1].stats) || {};

      var pc = parseInt(ps.count, 10) || 0;
      var pa = parseFloat(ps.average) || 0;
      var mc = parseInt(ms.total_reviews, 10) || 0;
      var ma = parseFloat(ms.average_rating) || 0;

      var total = pc + mc;
      if (!total) return;
      var avg = (pc * pa + mc * ma) / total;

      paint(total, avg);
      store(total, avg);
    }).catch(function () { /* Serverseitiger Stand bleibt stehen */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();
